export function init() {
  if ($('.my-iberostar-menu').length > 0) {
    let $menu_cnt = $('div.my-iberostar-menu');
    let bookingsCount = $menu_cnt.data('bookingsCount');
    let quotesCount = $menu_cnt.data('quotesCount');
    let bookingsMenuItem = $menu_cnt.find('li.my-bookings a');
    let quotesMenuItem = $menu_cnt.find('li.my-quotes a');

    if (bookingsCount > 0) {
      bookingsMenuItem.text(bookingsMenuItem.text() + ' (' + bookingsCount + ')');
    }
    if (quotesCount > 0) {
      quotesMenuItem.text(quotesMenuItem.text() + ' (' + quotesCount + ')');
    }
  }
}

init()
